"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTrailingSlash = exports.isValidEmail = exports.isNullOrWhiteSpace = exports.hasSpecialCharacters = exports.getUsersName = exports.getStringError = exports.formatPhoneNumber = exports.formatNumber = exports.capitalizeFirstLetter = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var isNullOrWhiteSpace = function isNullOrWhiteSpace(value) {
  return value === null || value === undefined || // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (0, _typeof2.default)(value) !== "object" && (!value || value.toString().trim().length === 0);
};

exports.isNullOrWhiteSpace = isNullOrWhiteSpace;

var formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
  if (phoneNumber) {
    return "".concat(phoneNumber.slice(0, 3), "-").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6));
  }
};

exports.formatPhoneNumber = formatPhoneNumber;

var getUsersName = function getUsersName(user) {
  if (user && user.firstName && user.lastName) {
    return "".concat(user.firstName, " ").concat(user.lastName);
  }

  return user && user.firstName || "";
};

exports.getUsersName = getUsersName;

var hasSpecialCharacters = function hasSpecialCharacters(value) {
  return /[^\w\s]/gi.test(value);
};

exports.hasSpecialCharacters = hasSpecialCharacters;

var isValidEmail = function isValidEmail(value) {
  // RFC 5322 Standard
  var emailRegex = // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value);
};

exports.isValidEmail = isValidEmail;

var formatNumber = function formatNumber(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

exports.formatNumber = formatNumber;

var capitalizeFirstLetter = function capitalizeFirstLetter(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

exports.capitalizeFirstLetter = capitalizeFirstLetter;

var getStringError = function getStringError(error) {
  if (error instanceof Error) {
    if (error.message) return error.message;
    return "Unknown Error";
  }

  return String(error);
};

exports.getStringError = getStringError;

var removeTrailingSlash = function removeTrailingSlash(str) {
  return str.replace(/\/+$/, "");
};

exports.removeTrailingSlash = removeTrailingSlash;